import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import type {
  AcceptedResponse,
  CreateRoleRequest,
  CreateUserRequest,
  CreateUserResponse,
  MessageResponse,
  RoleListResponse,
  RoleResponse,
  UpdateUserRolesRequest,
  UserListParams,
  UserListResponse,
} from './types';

export const listUsers = async (params?: UserListParams): Promise<UserListResponse> => {
  const { data } = await cycloneApiClient.get<UserListResponse>('/users', {
    params: {
      page: params?.page ?? 1,
      size: params?.size ?? 20,
      query: params?.query || undefined,
    },
  });

  return data;
};

export const createUser = async (request: CreateUserRequest): Promise<CreateUserResponse> => {
  const { data } = await cycloneApiClient.post<CreateUserResponse>('/users', request);
  return data;
};

export const listRoles = async (): Promise<RoleListResponse> => {
  const { data } = await cycloneApiClient.get<RoleListResponse>('/users/roles');
  return data;
};

export const createRole = async (request: CreateRoleRequest): Promise<RoleResponse> => {
  const { data } = await cycloneApiClient.post<RoleResponse>('/users/roles', request);
  return data;
};

export const deleteUser = async (id: number): Promise<AcceptedResponse> => {
  const { data } = await cycloneApiClient.delete<AcceptedResponse>(`/users/${id}`);
  return data;
};

export const updateUserRoles = async (id: number, request: UpdateUserRolesRequest): Promise<MessageResponse> => {
  const { data } = await cycloneApiClient.patch<MessageResponse>(`/users/${id}/roles`, request);
  return data;
};
